<div class="contact-us form-sagro mb-footer">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner"></app-banner-header>
    </div>
    <div class="page-able mt-md-5 mt-0 pt-md-3 pt-4">
        <div class="container">
            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-11 mx-auto">
                    <p class="mb-4">{{ isLang?.pleaseFill }}</p>
                    <form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)" novalidate>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="name" class="mb-md-0 mb-2">{{ isLang?.about }}</label>
                            </div>
                            <div class="col-md-5">
                                <div class="select-ver3" *ngIf="dataAbout.length != 0">
                                    <ng-select2
                                        [data]="dataAbout"
                                        placeholder="{{ isLang?.chooseOne }}"
                                        name="about"
                                        #about="ngModel"
                                        ngModel>
                                    </ng-select2>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="name" class="mb-md-0 mb-2">{{ isLang?.name }}</label>
                            </div>
                            <div class="col-md-10">
                                <input type="text" 
                                        class="form-control" 
                                        id="name" 
                                        required 
                                        #name="ngModel" 
                                        [class.is-invalid]="name.invalid && name.touched"
                                        name="name" 
                                        ngModel>
                                <small class="text-danger" 
                                        [class.d-none]="name.valid || name.untouched">
                                        {{ isLang?.name }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="company" class="mb-md-0 mb-2">{{ isLang?.company }}</label>
                            </div>
                            <div class="col-md-10">
                                <input type="text" 
                                        class="form-control" 
                                        id="company" 
                                        required 
                                        #company="ngModel" 
                                        [class.is-invalid]="company.invalid && company.touched"
                                        name="company" 
                                        ngModel>
                                <small class="text-danger" 
                                        [class.d-none]="company.valid || company.untouched">
                                        {{ isLang?.company }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="address" class="mb-md-0 mb-2">{{ isLang?.address }}</label>
                            </div>
                            <div class="col-md-10">
                                <textarea type="text" 
                                        class="form-control" 
                                        style="resize: none; height: 150px;"
                                        id="address" 
                                        required 
                                        #address="ngModel" 
                                        [class.is-invalid]="address.invalid && address.touched"
                                        name="address" 
                                        ngModel>
                                </textarea>
                                <small class="text-danger" 
                                        [class.d-none]="address.valid || address.untouched">
                                        {{ isLang?.address }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                            
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="phone" class="mb-md-0 mb-2">{{ isLang?.phone }}</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" 
                                        pattern="[0-9\/]*"
                                        class="form-control" 
                                        id="phone" 
                                        placeholder="08-XXX-XXX"
                                        required 
                                        #phone="ngModel" 
                                        [class.is-invalid]="phone.invalid && phone.touched"
                                        name="phone" 
                                        ngModel>
                                <small class="text-danger" 
                                        [class.d-none]="phone.valid || phone.untouched">
                                        {{ isLang?.phone }} {{ isLang?.numberRequired2 }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="fax" class="mb-md-0 mb-2">Fax</label>
                            </div>
                            <div class="col-md-5">
                                <input type="number" 
                                        class="form-control" 
                                        id="fax" 
                                        pattern="[0-9\/]*"
                                        required 
                                        #fax="ngModel" 
                                        [class.is-invalid]="fax.invalid && fax.touched"
                                        name="fax" 
                                        ngModel>
                                <small class="text-danger" 
                                        [class.d-none]="fax.valid || fax.untouched">
                                        Fax {{ isLang?.numberRequired2 }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="email" class="mb-md-0 mb-2">Email</label>
                            </div>
                            <div class="col-md-7">
                                <input type="email" 
                                        class="form-control" 
                                        id="email" 
                                        placeholder="example@domain.com"
                                        required 
                                        #email="ngModel" 
                                        [class.is-invalid]="email.invalid && email.touched"
                                        name="email" 
                                        ngModel 
                                        email
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$">
                                <small class="text-danger" 
                                        [class.d-none]="email.valid || email.untouched">
                                        Email "example@domain.com" {{ isLang?.isRequired }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-1 pr-md-0">
                                <label for="content" class="mb-md-0 mb-2">{{ isLang?.message }}</label>
                            </div>
                            <div class="col-md-10">
                                <textarea 
                                        class="form-control" 
                                        style="resize: none;height: 150px;"
                                        id="content" 
                                        required 
                                        #content="ngModel" 
                                        [class.is-invalid]="content.invalid && content.touched"
                                        name="content" 
                                        ngModel>
                                </textarea>
                                <small class="text-danger" 
                                        [class.d-none]="content.valid || content.untouched">
                                        {{ isLang?.message }} {{ isLang?.isRequired }}
                                </small>
                            </div>
                            
                        </div>
                        <div class="form-group row">
                            <div class="col-md-2 pt-md-1 pt-2 pr-md-0">
                                
                            </div>
                            <div class="col-md-10">
                                <!-- recaptcha -->
                                <div class="d-flex justify-content-md-start align-items-center justify-content-center">
                                    <div #recaptcha></div>
                                    <span *ngIf="infoCaptcha" class="text-danger h5 pl-3">
                                        <i class="icon ion-ios-information-circle-outline"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row mt-4">
                            <div class="col-md-2 pt-md-1 pt-2 pr-md-0">
                            </div>
                            <div class="col-md-10 text-md-left text-center">
                                <button *ngIf="!send" class="btn red-btn" [disabled]="contactForm.form.invalid || titleHasError" type="submit">{{ isLang?.send }}</button>
                                <button *ngIf="send" class="btn red-btn" type="button" disabled>
                                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>


